<template>
  <a-modal v-model="modal" title="新建" width="560px" :maskClosable="false" :closable="false">
    <div class="create-material" v-if="modal">
      <a-form-model :model="formData" ref="form">
        <a-form-model-item
          label="加工组织"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="organizationCode"
          :rules="rules.organizationCode"
        >
          <global-select
            v-model="formData.organizationCode"
            v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
            selectType="selectAssemble"
            :selectData="inventOrg"
            :disabled="isDisableOrganization"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :assembleLabel="true"
          />
        </a-form-model-item>
        <a-form-model-item
          label="模式编码"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="modeCode"
          :rules="rules.modeCode"
        >
          <a-input v-model="formData.modeCode" placeholder="请输入" :maxLength="40" />
        </a-form-model-item>
        <a-form-model-item
          label="模式名称"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="modeCode"
          :rules="rules.modeName"
        >
          <a-input v-model="formData.modeName" placeholder="请输入" :maxLength="40" />
        </a-form-model-item>
        <a-form-model-item
          label="工作开始时间"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="workStartTime"
          :rules="rules.workStartTime"
        >
          <a-time-picker
            style="width: 100%"
            v-model="formData.workStartTime"
            :default-value="moment('00:00:00', 'HH:mm:ss')"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
          />
        </a-form-model-item>
        <a-form-model-item
          label="工作结束时间"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="workEndTime"
          :rules="rules.workEndTime"
        >
          <a-time-picker
            style="width: 100%"
            v-model="formData.workEndTime"
            :default-value="moment('00:00:00', 'HH:mm:ss')"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
          />
        </a-form-model-item>
        <a-form-model-item
          label="出勤班次"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="workShift"
          :rules="rules.workShift"
        >
          <global-select
            :value.sync="formData.workShift"
            :selectData="workShiftList"
            selectType="selectFilter"
            :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="备注"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="remark"
        >
          <a-input v-model="formData.remark" placeholder="请输入" :maxLength="100" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment';

import cacheSearch from '@/mixins/cacheSearch'
import cacheRequest from '@/mixins/cacheRequest'
import { apiAttendanceModeUpdate } from '@/api/mes/productionPrepare/attendanceMode'

export default {
  name: 'CreateModal',
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'
    }
  },
  created() {
    this.cacheLookupRequest('WORK_SCHEDULE', { lookupType: 'WORK_SCHEDULE', current: 1, pageSize: 999 }, 'workShiftList')
  },
  data() {
    return {
      modal: false,
      formData: {
        organizationCode: '', //  组织
        modeCode: '', //  模式编码
        modeName: '', // 模式名称
        workStartTime: '00:00:00', // 工作开始时间
        workEndTime: '00:00:00', // 工作结束时间
        workShift: '', // 出勤班次
        remark: '' // 备注
      },
      loading: false,
      rules: {
        organizationCode: [{ required: true, message: ' ', trigger: 'change' }],
        modeCode: [{ required: true, message: ' ', trigger: 'change' }],
        modeName: [{ required: true, message: ' ', trigger: 'change' }],
        workStartTime: [{ required: true, message: ' ', trigger: 'change' }],
        workEndTime: [{ required: true, message: ' ', trigger: 'change' }],
        workShift: [{ required: true, message: ' ', trigger: 'change' }]
      },
      workShiftList: [] // 出勤班次列表
    }
  },
  methods: {
    moment,
    // 初始化
    show () {
      this.$set(this.formData, 'organizationCode', this.organizationCodeOrigin)
      this.$set(this.formData, 'modeCode', '')
      this.$set(this.formData, 'modeName', '')
      this.$set(this.formData, 'workStartTime', '00:00:00')
      this.$set(this.formData, 'workEndTime', '00:00:00')
      this.$set(this.formData, 'workShift', '')
      this.$set(this.formData, 'remark', '')
      this.modal = true
    },
    // 确认创建
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.loading = true;
          apiAttendanceModeUpdate(this.formData).then(res => {
            if (res?.code === 200) {
              this.$message.success('创建成功')
              this.$emit("refresh")
              this.modal = false
            } else {
              this.$message.error(res?.msg || '创建失败')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
